/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const s=s=>t=>"string"==typeof t&&t.startsWith(s),t=s("--"),r=s("var(--"),a=/var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;export{a as cssVariableRegex,t as isCSSVariableName,r as isCSSVariableToken};
//# sourceMappingURL=is-css-variable.js.map
